import { Flex, Grid, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/Back";
import CreateEditEvent from "../components/CreateEditEvent";
import LoadingPage from "../components/LoadingPage";
import Menu from "../components/Menu";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { FaPersonBooth } from "react-icons/fa";

export default function EventDetails() {
  const { id } = useParams();
  const [event, setEvent] = useState({});
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    setLoadingPage(true);
    baseService.get(
      config.services.event.getEventById + id,
      (res) => {
        setEvent(res.data);
      },
      (err) => console.log(err)
    );
    setLoadingPage(false);
  }, [id]);

  return (
    <div>
      <div className="container" />
      <Back title="Event Details" />
      <div className="content">
        {loadingPage ? (
          <LoadingPage />
        ) : Object.keys(event).length > 0 ? (
          <>
            <Link to={`/event/participant/${id}`}>
              <Flex alignItems="center" color="blue.500" mb={3}>
                <FaPersonBooth />
                <Text ml={2} fontSize="sm">
                  Lihat participant
                </Text>
              </Flex>
            </Link>
            <CreateEditEvent data={event} />
          </>
        ) : (
          <Grid placeItems="center" minHeight="var(--page-height)">
            tidak ada data
          </Grid>
        )}
      </div>
      <Menu />
    </div>
  );
}
